import { ReactNode } from "react";
import { FloatingNav } from "../FloatingNav";
import Footer from "../Footer";
import { PendingCouponBanner } from "./PendingCouponBanner";

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-background relative flex flex-col">
      {/* Gradient glow overlay at top */}
      <div className="absolute inset-x-0 top-0 h-96 bg-gradient-glow pointer-events-none z-0" />
      
      {/* Static Navigation */}
      <div className="relative z-20">
        <FloatingNav />
      </div>

      {/* Pending coupon banner — shown when user has unused targeted coupons */}
      <div className="relative z-10">
        <PendingCouponBanner />
      </div>
      
      {/* Main Content */}
      <main className="relative z-10 flex-1">
        {children}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
